export enum Breakpoint {
  PHONE = 'PHONE',
  TABLET = 'TABLET',
  DESKTOP = 'DESKTOP',
  WIDE = 'WIDE',
}

export const breakpoints = {
  [Breakpoint.PHONE]: 576,
  [Breakpoint.TABLET]: 768,
  [Breakpoint.DESKTOP]: 1024,
  [Breakpoint.WIDE]: 1280,
} as const;
